<aside class="inline-product">
  <span class="inline-product__label">{{ copy.inlineProductLabel }}</span>

  <div class="inline-product__body">
    <img
      class="inline-product__image"
      [src]="product().imageUrl"
      [alt]="product().name"
      width="48"
      height="64"
      loading="lazy"
    />

    <div class="inline-product__info">
      @if (view().link; as link) {
        <a class="inline-product__name inline-product__name--link" [routerLink]="link">{{
          product().name
        }}</a>
      } @else {
        <span class="inline-product__name">{{ product().name }}</span>
      }
      @if (view().showPrice) {
        <span class="inline-product__price">
          {{ product().price | crc }}
        </span>
      } @else if (view().soldOut) {
        <span class="inline-product__sold-out">{{ copy.productSoldOut }}</span>
      }
    </div>
  </div>
</aside>
